import React from 'react';

import { useTranslation, Trans } from "react-i18next";

function CompositeReinKey () {

    const { t } = useTranslation();

    const diameters = [4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 25];

    const equalStrength = {
      steel: [null, null, 10, 12, 14, 16, 18, 20, 22, 25],
      composite: [4, 4, 6, 8, 10, 12, 14, 16, 18, 20],
    };
  
    const metersPerTon = {
      steel: [null, 4505, 2532, 1621, 1126, 826, 633, 500, 405, 336, 260],
      composite: [50000, 27770, 12500, 7140, 4347, 3125, 2272, 1724, 1370, null, null],
    };
  
    const kgPerKm = {
      steel: [null, 220, 400, 620, 890, 1210, 1580, 2000, 2470, 2980, 3850],
      composite: [20, 36, 80, 140, 230, 320, 440, 580, 730, null, null],
    };
  
    const renderRow = (label, data) => (
      <tr>
        <td className="py-1">{label}</td>
        {data.map((val, idx) => (
          <td key={idx} className="py-1 text-right">{val ?? '-'}</td>
        ))}
      </tr>
    );
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] text-center open-sans text-[#F26522] leading-[1.4]">
                        <Trans>{t("addd.1")}</Trans>
                    </p>
                </div>
                <div className='overflow-x-auto '>       
                    <div className="text-white open-sans mt-[30px] xl:mt-[65px] min-w-[800px]">
                        <h2 className="text-[#F26522] mb-2 flex justify-between">
                            {t('compositerein.add.2')} <span className='text-white'>{t('compositerein.add.4')}</span>
                        </h2>
                        <table className="table-auto w-full mb-6 border-y-[3px] border-[#FFFFFF1A]">
                        <tbody>
                            {[
                                renderRow(t('compositerein.add.3'), equalStrength.steel),
                                renderRow(t('compositerein.add.5'), equalStrength.composite),
                            ].map((row, index) => (
                                <tr key={index} className="border-y-[3px] border-[#FFFFFF1A]">
                                {row.props.children}
                                </tr>
                            ))}
                        </tbody>
                        </table>
                        <h2 className="text-[#F26522] mb-2">
                            {t('compositerein.add.6')}
                        </h2>
                        <table className="table-auto w-full mb-6 border-y-[3px] border-[#FFFFFF1A]">
                            <thead className=''>
                            <tr>
                                <th className="py-1 text-left font-[400]">{t('compositerein.add.7')}</th>
                                {diameters.map((d, idx) => (
                                    <th key={idx} className="py-1 text-right font-[400]">{d}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                                {[
                                    renderRow(t('compositerein.add.8'), metersPerTon.steel),
                                    renderRow(t('compositerein.add.9'), metersPerTon.composite),
                                ].map((row, index) => (
                                    <tr key={index} className="border-y-[3px] border-[#FFFFFF1A]">
                                        {row.props.children}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <h2 className="text-[#F26522] mb-2">
                            {t('compositerein.add.10')}
                        </h2>
                        <table className="table-auto w-full border-y-[3px] border-[#FFFFFF1A]">
                            <thead>
                                <tr>
                                    <th  className="py-1 text-left font-[400]">{t('compositerein.add.11')}</th>
                                    {diameters.map((d, idx) => (
                                        <th key={idx} className="text-right font-[400]">{d}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {[
                                    renderRow(t('compositerein.add.12'), kgPerKm.steel),
                                    renderRow(t('compositerein.add.13'), kgPerKm.composite),
                                ].map((row, index) => (
                                    <tr key={index} className="border-y-[3px] border-[#FFFFFF1A]">
                                        {row.props.children}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CompositeReinKey;